import React from "react";
import ReactDOM from "react-dom/client";
import { PublicHeader } from "@dev-apps/common-ui-components";
import CustomerSupportCenter from "../../components/Legacy/Header/CustomerSupportCenter";
import Menu from "../../components/Legacy/Menu/Menu";
import SessionHandler from "../../components/shared/SessionHandler";

const root = ReactDOM.createRoot(document.getElementById("sewp-legacy-header"));
root.render(
  <React.StrictMode>
    <SessionHandler appType={"public"}>
      <PublicHeader CustomerSupportCenter={CustomerSupportCenter} basePath={process.env.NEXT_PUBLIC_BASE_PATH}/>
      <Menu />
    </SessionHandler>
  </React.StrictMode>
)
